module.exports = __webpack_public_path__ + "static/img/ico-scienc.c56c6cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico-scienc.png
// module id = gHJb
// module chunks = 2